import type { AnalyticsFacet } from "../../../../stores/tars/tars-analytics-store";
import { resolveEtlNodeFromDocument } from "./facet-etl-document-helpers";
import { extractFacetTableData, isMatrixTableData } from "./facet-table-helpers";

function hasMatrixFacetResult(facetResult: Record<string, unknown> | undefined): boolean {
  if (!facetResult) return false;
  const table = extractFacetTableData(facetResult);
  if (isMatrixTableData(table)) return true;
  const rows = facetResult.rows;
  return Array.isArray(rows) && rows.some((row) => Array.isArray(row) && row.length > 2);
}

function hasMatrixShapedEtl(etlJson: Record<string, unknown> | undefined): boolean {
  if (!etlJson) return false;
  const etlNode = resolveEtlNodeFromDocument(etlJson);
  if (!etlNode) return false;
  const ops = etlNode.ops;
  if (!Array.isArray(ops)) return false;
  return ops.some((op) => {
    if (op == null || typeof op !== "object") return false;
    const rec = op as Record<string, unknown>;
    const type = String(rec.type ?? "");
    if (type === "matrix") return true;
    if (type !== "pivot") return false;
    const rowKey = String(rec.row_key ?? "").trim();
    const colKey = String(rec.col_key ?? "").trim();
    return Boolean(rowKey) && Boolean(colKey);
  });
}

export function isFacetMatrixTable(facet: AnalyticsFacet): boolean {
  if (hasMatrixFacetResult(facet.facet_result as Record<string, unknown> | undefined)) {
    return true;
  }
  return hasMatrixShapedEtl(facet.etl_json as Record<string, unknown> | undefined);
}
